import React, { useRef, useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, Container, FormControl, IconButton, MenuItem, TextField, Typography, Grid2 as Grid } from '@mui/material';
// import dayjs from 'dayjs';
// import { format } from 'date-fns';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
// // import { validateRequired } from '../../../../utils/common';
// import { CustomDateTimePicker } from '../../../../components/datetimepicker';
import { useTestSearchContext } from '../contexts/test-search.context';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import { formatPrice } from '../../../../utils/utils';
import { addToCart, updateCartOrderInfo } from '../../../../redux/actions/cartactions';
import {ReactComponent as LabTest} from '../../../../assets/images/labtest.svg';
import httpClient from '../../../../services/http';
import { APIUtils } from '../../../../utils/apiutils';
import Spinner from '../../../../components/spinner/spinner';
// import Notify from '../../../../components/notify/notify.component';
// import Grid from '@mui/material/Grid2';

const LabtestFilters = () => {
    const { setTests } = useTestSearchContext();
    const [formData, setFormData] = useState({});
    // const [errors, setErrors] = useState({});
    const formSubmitted = useRef(false);
    const [loading, setLoading] = useState(false);
    // const [categories, setCategories] = useState([]);

    // const goToDetailsPage = () => {
    //     navigate('/medicinedetails/1');
    // };

    const testSubCategories = [
        { value: '', label: '--Select Category--' },
        { value: '1', label: 'Biochemistry' },
        { value: '2', label: 'Urea Test' },
        { value: '3', label: 'Lipid Test' },
        { value: '4', label: 'Other Tests' }
    ];

    // const requiredFields = ['category'];
    const setFormValue = (field, value) => {
        const tmp = { ...formData, [field]: value };
        setFormData(tmp);
        // if (formSubmitted.current) {
        //     const errors = validateRequired(requiredFields, tmp);
        //     setErrors(errors);
        // }
    };

    const handleSearch = async () => {
        formSubmitted.current = true;
        // const errors = validateRequired(requiredFields, formData);
        // console.log({errors});
        // if (errors) {
        //     setErrors(errors); return;
        // }
        // if (!isValid()) {
        //     return;
        // }
        try {
            setLoading(true);
            const paramsData = {};
            if (formData.category) {
                paramsData.cat = formData.category;
            }
            if (formData.searchQuery) {
                paramsData.q = formData.searchQuery;
            }
            const params = new URLSearchParams(paramsData).toString();
            const url = `${APIUtils.getAPIEndpoint('user-tests')}?${params}`;
            const res = await httpClient.get(url);
            console.log({res});
            if (res.status === 200) {
                setTests(res.data.data);
                // setSearchStep(2);
            }
        } catch (error) {
                console.log(error);
                Swal.fire('Something Went Wrong!', '', 'error');
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     const getCategories = async () => {
    //         try {
    //             const res = await httpClient.get(APIUtils.getAdminAPIEndpoint('testlist')).then(res => res.data);
    //             if (res.status === 'success') {
    //                 setCategories(res.data);
    //             }
    //         } catch (e) {
    //             console.log(e);
    //         }
    //     };
    //     getCategories();
    // }, []);

    // const date = testDate ? new Date(testDate) : new Date();
    // const testDateUI = (
    //     <CustomDateTimePicker
    //         name="testDate"
    //         value={dayjs(date)}
    //         handleChange={(value) => setTestDate(format(new Date(value), DATE_FORMAT))}
    //         dateOnly={true}
    //         label="Test Date"
    //         className="small-time-picker-test"
    //     />
    // );

    const searchTestBtn = () => {
        if (loading) {
            return <Button variant='contained' className='small-brown-btn'>Searching&nbsp;<Spinner /></Button>;
        }
        return <Button variant='contained' fullWidth className='btn-square' onClick={handleSearch}>Search</Button>;
    };

    return (
        <Grid
            container
            spacing={2}
            sx={{
                display: 'flex',
                justifyContent: 'center',
            }}
            style={{width: '80%', margin: '0 auto'}}
        >
            <Grid size={{ xs: 12, sm: 3 }}>
                <FormControl fullWidth>
                    <TextField
                        label='Category'
                        value={formData.category || ''}
                        fullWidth
                        size='small'
                        select
                        onChange={e => setFormValue('category', e.target.value)}
                        // {...(errors.category ? { error: true, helperText: 'This field is required.' } : {})}
                    >
                        {testSubCategories.map(sm => <MenuItem key={`sm-menu-${sm.value}`} value={sm.value} name={sm.label}>{sm.label}</MenuItem>)}
                    </TextField>
                </FormControl>
            </Grid>
            {/* <Grid item xs={12} sm={3}>
                {testDateUI}
            </Grid> */}
            <Grid size={{ xs: 12, sm: 3 }}>
                <FormControl fullWidth>
                    <TextField
                        label='Search Query'
                        variant='outlined'
                        size='small'
                        fullWidth
                        value={formData.searchQuery || ''}
                        onChange={e => setFormValue('searchQuery', e.target.value)}
                        // {...(errors.searchQuery ? { error: true, helperText: 'This field is required.' } : {})}
                    />
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
                <FormControl fullWidth>
                    {searchTestBtn()}
                </FormControl>
            </Grid>
        </Grid>
    );
};

const TestItem = ({id, servicename, description, serviceprice, discount}) => {
    // const navigate = useNavigate();
    const { cartTracker } = useSelector(state => state.cart);
    const { collectionType, selectedLocation, testDate, coordinate, city, testType } = useTestSearchContext();
    const hasDiscount = discount ? true : false;
    const price = hasDiscount ? (+serviceprice - (+serviceprice * +discount)/100) : +serviceprice;

    const handleAddToCart = () => {
        // NOTE: Item should be of TestCartItemType as defined in app.test.js file.
        const cartItem = {id, name: servicename, description, price: +price};
        addToCart(cartItem);
        updateCartOrderInfo({ collectionType, selectedLocation, testDate, coordinate, city, testType });
        // Swal.fire(`${servicename}`, 'Added to cart successfully.', 'success');


        document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.TOGGLE_NOTIFY, { detail: { open: true, message: `${servicename} - Added to cart successfully.` } }));
    };

    const priceUI = () => {
        if (hasDiscount) {
            return (
                <div className="style-1">
                    <del>
                        <span className="amount">{formatPrice(+serviceprice)}</span>
                    </del>
                    <ins>
                        <span className="amount">{formatPrice(+price)}</span>
                    </ins>
                </div>
            );
        }

        return (
            <Typography variant="h6" display="block" gutterBottom>
                {formatPrice(+serviceprice)}
            </Typography>
        );
    };
    return (
        <Card className="test-item-container">
            <div className="opt-img-wrapper">
                <LabTest />
            </div>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {servicename}
                </Typography>
                <Typography variant="subtitle1" display="block" gutterBottom>
                    {description}
                </Typography>
                {/* <div className="style-1">
                    <del>
                        <span className="amount">{formatPrice(+serviceprice)}</span>
                    </del>
                    <ins>
                        <span className="amount">{formatPrice(+serviceprice)}</span>
                    </ins>
                </div>
                <Typography variant="h6" display="block" gutterBottom>
                    {formatPrice(+serviceprice)}
                </Typography> */}
                {priceUI()}
            </CardContent>
            <CardActions>
                <Button variant='contained' className='btn-square' onClick={handleAddToCart} disabled={cartTracker.has(id)}>
                <AddIcon />&nbsp;Add To Cart
                </Button>
            </CardActions>
            {/* <Box>
            </Box> */}
        </Card>
    );
};
TestItem.propTypes = {
    servicename: PropTypes.string,
    description: PropTypes.string,
    serviceprice: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    discount: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
};

const TestResults = () => {
    const { tests } = useTestSearchContext();
    // const TESTS = [
    //     {
    //         id: 1,
    //         name: 'Post Glucose Blood Sugar(PGBS)',
    //         description: 'Testing after 2 hours of having food',
    //         price: 70
    //     },
    //     {
    //         id: 2,
    //         name: 'Post Glucose Blood Sugar(PGBS)',
    //         description: 'Testing after 2 hours of having food',
    //         price: 80
    //     },
    //     {
    //         id: 3,
    //         name: 'Post Glucose Blood Sugar(PGBS)',
    //         description: 'Testing after 2 hours of having food',
    //         price: 790
    //     },
    //     {
    //         id: 4,
    //         name: 'Post Glucose Blood Sugar(PGBS)',
    //         description: 'Testing after 2 hours of having food',
    //         price: 70.85
    //     },
    //     {
    //         id: 5,
    //         name: 'Post Glucose Blood Sugar(PGBS)',
    //         description: 'Testing after 2 hours of having food',
    //         price: 6500
    //     },
    //     {
    //         id: 6,
    //         name: 'Post Glucose Blood Sugar(PGBS)',
    //         description: 'Testing after 2 hours of having food',
    //         price: 763
    //     },
    //     {
    //         id: 7,
    //         name: 'Post Glucose Blood Sugar(PGBS)',
    //         description: 'Testing after 2 hours of having food',
    //         price: 70
    //     },
    // ];

    const testResultsUI = tests.map(test => <TestItem key={test.id} {...test} />);
    return (
        <div className="labtest-results">
            {testResultsUI}
        </div>
    );
};

const LabTests = () => {
    const { setSearchStep } = useTestSearchContext();
    const handleBack = () => {
        setSearchStep(1);
    };
    return (
        <Container className='labtests-container'>
            {/* <Box>
                <Typography className='ext-large-brown-txt'>
                    Lab Tests
                </Typography>
            </Box> */}
            <Box style={{position: 'relative'}} className="centerContent">
                <IconButton aria-label="back" onClick={handleBack} style={{position: 'absolute', left: '0'}}>
                    <ArrowBackIcon />
                </IconButton>
                <LabtestFilters />
            </Box>
            <TestResults />
        </Container>
    );
};

export default LabTests;